
export const ERROR = 'ERROR';
export const INVALID_REQUEST = 'INVALID_REQUEST';
export const OK = 'OK';
export const OVER_QUERY_LIMIT = 'OVER_QUERY_LIMIT';
export const REQUEST_DENIED = 'REQUEST_DENIED';
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
export const ZERO_RESULTS = 'ZERO_RESULTS';
